import { slugify } from "@/lib/productUrl";

/**
 * Top-level path segments that are real pages, so they can never be
 * mistaken for a category slug.
 */
export const RESERVED_TOP_SEGMENTS = new Set([
  "shop",
  "brand",
  "brands",
  "about",
  "product",
  "blog",
  "business",
  "cookies-policy",
  "privacy-policy",
  "purchase-terms",
  "reset-password",
  "admin",
]);

/** `/bathroom` or `/bathroom/basin-faucets` (no language prefix). */
export const buildCategoryPath = (category: string, subcategory?: string | null): string => {
  const cat = slugify(category || "");
  if (!cat) return "/shop";
  const sub = subcategory ? slugify(subcategory) : "";
  return sub ? `/${cat}/${sub}` : `/${cat}`;
};

/** Find the canonical name whose slug matches `slug`. */
export const matchSlug = (slug: string, names: readonly string[]): string | null => {
  const target = (slug || "").toLowerCase();
  return names.find((n) => slugify(n) === target) || null;
};

/** Human-readable fallback for a slug we cannot map to a known name yet. */
export const deslugify = (slug: string): string =>
  (slug || "")
    .split("-")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export { slugify };
